<!--
 * @名称: 车辆详情
 * @Descripttion: ml 创建
 * @Author: ml
 * @Date: 2019-12-16 11:44:45
 * @LastEditors  : ml
 * @LastEditTime : 2020-08-12 15:21:06
 -->
<template>
  <div class="ml_cardetail">
    <van-swipe indicator-color="white" @change="onChange">
      <template v-for="(item,index) in climages">
        <van-swipe-item @click="imgPreview(index)" :key="index">
          <van-image :width="imgWidth" :height="imgHeight" :src="item.cfg_att_url +'?x-oss-process=image/resize,w_640,h_480/quality,q_90'">
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
            <template v-slot:error>加载失败</template>
          </van-image>
        </van-swipe-item>
      </template>
      <div class="custom-indicator" slot="indicator">
        <img src="../../assets/icon.png" class="ml_img_icon" />
        {{ current + 1 }}/{{climages.length}}
      </div>
    </van-swipe>
    <div class="ml_carinfo">
      <div class="ml_carname">{{vehicle_name}}</div>
      <div class="ml_carbase">
        <span class="ml_line_carbase">{{plate_number}}</span>
        <span class="ml_line_carbase">{{date_register}}</span>
        <span class="ml_line_carbase">{{mileage}}</span>
      </div>
    </div>

    <van-cell size="large" :border="false">
      <template slot="title">
        <span class="custom-title">综合车况描述</span>
      </template>

      <template slot="label">
        <div class="custom-label">{{summary}}</div>
      </template>
    </van-cell>

    <div class="ml_tab_list">
      <div class="ml_tab_item">
        外观 {{appearancescore}}
      </div>
      <div class="ml_tab_item">
        骨架 {{skeletonscore}}
      </div>
      <div class="ml_tab_item">
        内饰 {{interiorscore}}
      </div>
    </div>

    <van-cell-group>
      <van-cell title="车辆信息" is-link @click="goToPage(0)" />
      <van-cell title="检测报告" is-link @click="goToPage(1)" />
    </van-cell-group>

    <div class="ml_detection_line"></div>

    <!-- 图片预览 -->
    <van-image-preview v-model="showImgView" :images="sizeClimages" :start-position="startIndex" @change="onChangeView">
      <template v-slot:cover>
        {{imgText}}
      </template>
    </van-image-preview>

  </div>
</template>
<script>
import {
  GetVehicleInfoById
} from '@/api/carDetail'

export default {
  data () {
    return {
      carID: 0,
      current: 0,
      reportid: '',

      showImgView: false,
      startIndex: 0,
      climages: [],
      imgText: '',
      sizeClimages: [],
      imgWidth: window.screen.width,
      imgHeight: window.screen.width * 3 / 4,

      vehicle_name: '',
      plate_number: '',
      date_register: '',
      mileage: '',
      summary: '',
      skeletonscore: '',
      appearancescore: '',
      interiorscore: '',
      detection_report: ''
    }
  },
  mounted () {
    this.carID = this.$route.query.cid
    this.getCarDetail()
  },
  methods: {
    onClickLeft () {
      location.href = 'carwins://go?back'
    },
    goToPage (i) {
      switch (i) {
        case 0:
          // 车辆信息
          location.href = 'carwins://gopage?page=vehicledetail&cid=' + this.carID + '&mapid=' + this
            .reportid
          break
        case 1:
          // 检测报告
          if (this.detection_report) {
            this.$router.push({
              path: '/detectiondetail',
              query: {
                url: encodeURIComponent(this.detection_report)
              }
            })
          }
          break
      }
    },
    onChange (index) {
      this.current = index
    },
    onChangeView (i) {
      this.imgText = this.climages[i].cfg_att_name || ''
    },
    imgPreview (i) {
      this.startIndex = i
      this.imgText = this.climages[i].cfg_att_name || ''
      let _imgArray = []
      this.climages.forEach(element => {
        _imgArray.push(element.cfg_att_url + '?x-oss-process=image/resize,w_1280,h_960/quality,q_90')
      })
      this.sizeClimages = _imgArray
      this.showImgView = true
    },
    getCarDetail () {
      const that = this
      GetVehicleInfoById({
        cId: that.carID
      }).then(res => {
        that.climages = res.data.climages
        that.vehicle_name = res.data.vehicle_name || '-'
        that.plate_number = res.data.plate_number || '-'
        if (res.data.date_register) {
          that.date_register = res.data.date_register.replace(/-/g, '.')
        } else {
          that.date_register = '-'
        }

        if (res.data.mileage) {
          that.mileage = res.data.mileage / 10000 + '万公里'
        } else {
          that.mileage = '-'
        }

        that.summary = res.data.summary || '-'

        that.skeletonscore = res.data.skeletonscore || '-'
        that.appearancescore = res.data.appearancescore || '-'
        that.interiorscore = res.data.interiorscore || '-'

        that.detection_report = res.data.detection_report || ''

        that.reportid = res.data.reportid
      })
    }
  }
}

</script>
<style lang="scss">
.ml_cardetail {
  // padding-top: 46px;

  .van-swipe-item {
    .ml_cardetail_img {
      object-fit: cover;
      display: inline-block;
    }
  }

  .custom-indicator {
    position: absolute;
    left: 10px;
    bottom: 15px;
    padding: 5px;
    color: #fff;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.5);

    .ml_img_icon {
      width: 15px;
      display: inline-block;
      vertical-align: middle;
      font-size: 0;
      margin-top: -3px;
    }
  }

  .van-image-preview__cover {
    bottom: 10px;
    color: #fff;
    left: 0;
    width: 100%;
    text-align: center;
    top: unset;
  }

  .ml_carinfo {
    padding: 10px 16px;
    border-bottom: 10px solid #f2f2f2;

    .ml_carname {
      font-size: 18px;
      font-weight: bold;
      padding-bottom: 10px;
    }

    .ml_carbase {
      color: #9a9a9a;

      .ml_line_carbase {
        padding-right: 10px;

        &::after {
          content: "|";
          margin-left: 10px;
          font-size: 12px;
        }

        &:last-child {
          &::after {
            content: "";
          }
        }
      }
    }
  }

  .custom-title {
    font-size: 16px;
    font-weight: bold;
  }

  .custom-label {
    padding: 16px;
    margin-top: 15px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
  }

  .ml_tab_list {
    border-top: 1px solid #f1f1f1;
    padding: 10px 20px;
    display: flex;
    border-bottom: 10px solid #f2f2f2;

    .ml_tab_item {
      flex: 1;
      text-align: center;
      padding: 5px 0;
      color: #ff7901;
      border: 1px solid #ff7901;

      &:nth-child(2n) {
        border-right: 0;
        border-left: 0;
      }

      &:first-child {
        border-top-left-radius: 15px;
        border-bottom-left-radius: 15px;
      }

      &:last-child {
        border-top-right-radius: 15px;
        border-bottom-right-radius: 15px;
      }
    }
  }

  .ml_detection_line {
    border-bottom: 10px solid #f2f2f2;
  }
}
</style>
